import { queryClient } from './queryClient.ts';
import type { CacheEntity } from './queryKeys.ts';

/**
 * Mark every cached entry of the given entities stale.
 *
 * Called by `services/api.ts` after each successful mutation, so freshness is enforced at the one place
 * every write passes through. Stale entries are NOT discarded: a screen showing one keeps showing it and
 * refetches in the background, and an off-screen one refetches the next time it is viewed. Only entries
 * currently on screen refetch immediately.
 *
 * This module must not import `services/api.ts` (api.ts imports it).
 */
export const invalidateEntities = (...entities: CacheEntity[]): void => {
  for (const entity of entities) {
    void queryClient.invalidateQueries({ queryKey: [entity] });
  }
};
